import Loadable from "react-loadable";
import LoadingComponent from "../../../../commons/loader";

export default [
  {
    path: "/clients/:customer_id/company/:company_id/customers/:customer_product_id?",
    exact: false,
    auth: true,
    component: Loadable({
      loader: () => import("./pages/index"),
      loading: LoadingComponent
    })
  }
];



// WEBPACK FOOTER //
// ./src/modules/company/pages/customer/routes.js